<template>
  <div class="formcell">
    <slot>
      <label :for="id" :class="labelClass" class="label">
        {{ label }}
      </label>
    </slot>
    <input
      v-if="!tel"
      :id="id"
      :value="value"
      :type="type"
      :name="id"
      :placeholder="placeholder"
      :required="required"
      class="input w-input"
      maxlength="256"
      autocomplete="off"
      @input="$emit('input', $event.target.value)"
    >
    <MaskedInput
      v-else
      v-model="val"
      mask="\+\7–111–111–11–11"
      :type="tel ? 'tel' : 'text'"
      :id="id"
      :name="id"
      :placeholder="placeholder"
      :required="required"
      class="input w-input"
      maxlength="256"
      autocomplete="off"
    />
  </div>
</template>

<script>
  import MaskedInput from 'vue-masked-input';

  export default {
    name: 'Formcell',
    components: {MaskedInput},
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      id: {
        type: String,
        required: true,
      },
      value: String,
      label: String,
      labelClass: String,
      placeholder: String,
      tel: Boolean,
      required: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'text',
      },
    },
    data () {
      return {
        val: this.value,
      };
    },
    watch: {
      val (val) {
        if (this.tel && val !== this.value) this.$emit('input', val);
      },
      value (val) {
        if (this.tel) this.val = val;
      },
    },
  };
</script>
